import 'firebase/auth';

import firebase from 'firebase/app';

export const firebaseApp = firebase;
